import React from 'react';
import './widget-header.scss';
import { useGlobalBackButton } from '../../GlobalBackButtonContext';
import { Button } from '../Button/Button';

const ICON_CLOSE = <svg viewBox="0 0 1024 1024">
    <path
        d="M874.572 85.333l64.094 64.094-362.581 362.572 362.581 362.572-64.094 64.094L512 576.084 149.428 938.665l-64.094-64.094 362.539-362.572L85.334 149.427l64.094-64.094L512 447.872 874.572 85.333z"
        fill="inherit"
        stroke="inherit"
        stroke-width="inherit"
        stroke-linejoin="inherit"
        stroke-linecap="inherit"
        stroke-miterlimit="inherit"
    />
</svg>;

const WIDGET_HEADER_ID = 'widget-header';

export const WidgetHeader = ({ title, onClose = null }) => {
    const { onBack } = useGlobalBackButton();
    return (
        <header id={WIDGET_HEADER_ID}>
            {onBack && <div style={{ position: 'absolute', top: '17px' }}>
                <Button.GO_BACK_FORM_TITLE onBackPress={onBack} disabled={false} />
            </div>}
            <div id="widget-title">{title || 'online запись'}</div>
            <span id="inner-close-button" onClick={onClose}>
                {ICON_CLOSE}
            </span>
            {/* <button
                id="close-button"
                onClick={onClose}
                aria-label="Close"
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
            >
                {ICON_CLOSE}
            </button> */}
        </header>
    );
};
